var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBackArrowCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#1D1B18",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.629 6.972a.889.889 0 0 0-1.18-.07l-.078.07-4.4 4.4a.889.889 0 0 0-.068 1.179l.069.078 4.4 4.4a.889.889 0 0 0 1.326-1.18l-.07-.078L9.859 12l3.77-3.771a.889.889 0 0 0 .07-1.18l-.07-.077Z",
  fill: "#FFF",
  fillRule: "nonzero"
}))));

export default SvgBackArrowCircle;